import C from "../constants";

const initialState = {
  users: {
    status: "pending",
    data: [],
    originalData: [],
  },
  countryBrands: {
    status: "pending",
    data: {},
  },
  searchUsers: {
    status: "pending",
    data: [],
  },
};

const aideConsole = (state = initialState, action) => {
  switch (action.type) {
    case C.AIDE_CONSOLE_UPDATE_USERS:
      return {
        ...state,
        users: {
          status: "success",
          data: action.data,
          originalData: action.data,
        },
      };
    case C.AIDE_CONSOLE_UPDATE_USER_LIST:
      return {
        ...state,
        users: {
          ...state.users,
          data: action.data,
        },
      };
    case C.AIDE_CONSOLE_UPDATE_COUNTRY_BRANDS:
      return {
        ...state,
        countryBrands: {
          status: "success",
          data: action.data,
        },
      };
    case C.AIDE_CONSOLE_UPDATE_SEARCH_USERS:
      return {
        ...state,
        searchUsers: {
          status: "success",
          data: action.data,
        },
      };
    case C.AIDE_CONSOLE_CLEAN_SEARCH_USERS:
      return {
        ...state,
        searchUsers: {
          status: "pending",
          data: [],
        },
      };
    case C.AIDE_CONSOLE_RESET:
      return initialState;
    default:
      return state;
  }
};

export default aideConsole;
